(function () {
  let accessStorageKey = 'hungryminds.blackbook.accessGranted';

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function toArray(items) {
    return Array.prototype.slice.call(items);
  }

  function hasBlackbookAccess() {
    try {
      return window.localStorage.getItem(accessStorageKey) === 'true';
    } catch (error) {
      return false;
    }
  }

  function saveBlackbookAccess() {
    try {
      window.localStorage.setItem(accessStorageKey, 'true');
    } catch (error) {}
  }

  function initBlackbookModal() {
    let modal = document.querySelector('[data-blackbook-modal]');

    if (!modal || modal.dataset.blackbookInit === 'true') {
      return;
    }

    modal.dataset.blackbookInit = 'true';

    if (hasBlackbookAccess()) {
      modal.classList.remove('active');
      return;
    }

    document.documentElement.classList.add('blackbook-modal-open');
    document.body.classList.add('modal-open');

    let password = modal.dataset.blackbookPassword;
    let steps = toArray(modal.querySelectorAll('[data-blackbook-step]'));
    let passwordForm = modal.querySelector('[data-blackbook-password-form]');
    let passwordInput = passwordForm ? passwordForm.querySelector('input[name="password"]') : null;
    let passwordError = modal.querySelector('[data-blackbook-password-error]');
    let subscriptionForm = modal.querySelector('[data-blackbook-subscription-form]');
    let subscriptionInput = subscriptionForm ? subscriptionForm.querySelector('input[name="email"]') : null;
    let subscriptionError = modal.querySelector('[data-blackbook-subscription-error]');
    let copyButton = modal.querySelector('[data-blackbook-copy-password]');

    function showStep(name) {
      if (name === 'password' && passwordForm && passwordInput) {
        passwordForm.reset();
        passwordInput.removeAttribute('aria-invalid');
        if (passwordError) passwordError.hidden = true;
      }

      steps.forEach(function (step) {
        step.hidden = step.dataset.blackbookStep !== name;
      });

      let activeStep = steps.find(function (step) {
        return step.dataset.blackbookStep === name;
      });
      let input = activeStep ? activeStep.querySelector('input:not([type="hidden"])') : null;

      if (input) {
        // input.focus();
      }
    }

    function setSubscriptionLoading(loading) {
      if (!subscriptionForm) {
        return;
      }

      let button = subscriptionForm.querySelector('button[type="submit"]');
      if (button) {
        button.disabled = loading;
        button.classList.toggle('is-loading', loading);
      }
    }

    modal.querySelectorAll('[data-blackbook-show-subscribe]').forEach(function (link) {
      link.addEventListener('click', function (event) {
        event.preventDefault();
        showStep('subscribe');
      });
    });

    modal.querySelectorAll('[data-blackbook-show-password]').forEach(function (element) {
      element.addEventListener('click', function (event) {
        event.preventDefault();
        showStep('password');
      });
    });

    if (passwordInput) {
      passwordInput.addEventListener('input', function () {
        passwordInput.removeAttribute('aria-invalid');
        if (passwordError) passwordError.hidden = true;
      });
    }

    if (passwordForm && passwordInput) {
      passwordForm.addEventListener('submit', function (event) {
        event.preventDefault();

        if (passwordInput.value.trim().toUpperCase() !== password.toUpperCase()) {
          passwordInput.setAttribute('aria-invalid', 'true');
          if (passwordError) passwordError.hidden = false;
          return;
        }

        saveBlackbookAccess();
        passwordForm.reset();
        modal.classList.remove('active');
        document.documentElement.classList.remove('blackbook-modal-open');
        document.body.classList.remove('modal-open');
        window.scrollTo(0, 0);
      });
    }

    if (subscriptionInput) {
      subscriptionInput.addEventListener('input', function () {
        if (subscriptionError) subscriptionError.hidden = true;
      });
    }

    if (subscriptionForm) {
      subscriptionForm.addEventListener('submit', async function (event) {
        event.preventDefault();

        if (subscriptionForm.dataset.loading === 'true') {
          return;
        }

        if (!subscriptionForm.checkValidity()) {
          subscriptionForm.reportValidity();
          return;
        }

        subscriptionForm.dataset.loading = 'true';
        if (subscriptionError) subscriptionError.hidden = true;
        setSubscriptionLoading(true);

        try {
          let result = await submitFormData(subscriptionForm);
          if (!result.isSuccess) {
            throw new Error('Subscription request failed.');
          }

          subscriptionForm.reset();
          showStep('code');
        } catch (error) {
          if (subscriptionError) subscriptionError.hidden = false;
        } finally {
          delete subscriptionForm.dataset.loading;
          setSubscriptionLoading(false);
        }
      });
    }

    if (copyButton && navigator.clipboard) {
      copyButton.addEventListener('click', async function () {
        try {
          await navigator.clipboard.writeText(password);
          copyButton.textContent = 'Copied';
          setTimeout(function () {
            copyButton.textContent = 'Copy';
          }, 1500);
        } catch (error) {}
      });
    }

    showStep('password');
  }

  ready(initBlackbookModal);
})();
